import React, { useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, CompassColor, Text, IconButton } from '@noom/wax-component-library';
import { toHumanString } from '../../../../helpers/toHumanString';
import Avatar from '../../../../core/components/Avatar';
export function Community({ data, onClick, isSelected, isDisabled }) {
    const handleClick = () => {
        if (!isDisabled) {
            onClick === null || onClick === void 0 ? void 0 : onClick(data);
        }
    };
    return (React.createElement(Box, { borderRadius: "md", display: "flex", flexDir: "row", bg: CompassColor.offWhite, onClick: handleClick, p: 4, gap: 4, boxShadow: isSelected ? 'outline' : 'none', userSelect: "none", cursor: "pointer" },
        React.createElement(Avatar, { isCommunity: true, size: "regular", avatar: data.avatarUrl }),
        React.createElement(Box, { flex: 1 },
            React.createElement(Box, { display: "flex", flexDir: "row" },
                React.createElement(Box, { flex: 1 },
                    React.createElement(Box, null,
                        React.createElement(Text, { fontWeight: "500", isTruncated: true }, data.name)),
                    React.createElement(Box, null,
                        React.createElement(Text, { color: "gray.500", size: "sm" },
                            React.createElement(FormattedMessage, { id: "onboarding.communities.membersCount", values: {
                                    count: toHumanString(data.membersCount),
                                } })))),
                React.createElement(IconButton, { size: "md", icon: isSelected ? 'check' : 'add', borderRadius: "full", colorScheme: isSelected ? 'primary' : 'gray' })),
            React.createElement(Box, null,
                React.createElement(Text, { size: "sm", noOfLines: 2, title: data.description }, data.description)))));
}
function CommunitiesContainer({ children }) {
    return (React.createElement(Box, { display: "flex", flexDir: "column", "flex-wrap": "wrap", gap: 2, paddingX: 1 }, children));
}
export function CommunitySelect({ communities, isDisabled, onChange }) {
    const sortedCommunities = useMemo(() => [...communities].sort((a, b) => a.name.localeCompare(b.name)), [communities]);
    const [selected, setSelected] = useState([]);
    const onToggle = (data) => {
        if (isDisabled) {
            return;
        }
        let updatedArray = [];
        if (selected.find((c) => c.id === data.id)) {
            updatedArray = selected.filter((c) => c.id !== data.id);
        }
        else {
            updatedArray = [...selected, data];
        }
        setSelected(updatedArray);
        onChange === null || onChange === void 0 ? void 0 : onChange(updatedArray);
    };
    return (React.createElement(CommunitiesContainer, null, sortedCommunities.map((community) => (React.createElement(Community, { key: community.name, data: community, onClick: onToggle, isDisabled: isDisabled, isSelected: selected.some((c) => c.id === community.id) })))));
}
//# sourceMappingURL=CommunitySelect.js.map